export const adminBookmarksLocales = {
  'admin.bookmarks.title': 'Favoris internet de {firstName} {lastName}',

  'admin.bookmarks.error': 'Erreur lors de la récupération des favoris',

  'admin.bookmarks.empty': 'Aucun favori',

  'admin.bookmarks.button.createFolder': 'Créer un dossier',
  'admin.bookmarks.button.updateFolder': 'Modifier le dossier',
  'admin.bookmarks.button.deleteFolder': 'Supprimer le dossier',

  'admin.bookmarks.folder.subtitle': 'Ce dossier contient {numberOfBookmarks} favori(s)',
  'admin.bookmarks.folder.empty': 'Le dossier est vide',

  'admin.bookmarks.folder.create.title': 'Créer un dossier',
  'admin.bookmarks.folder.create.success': 'Le dossier "{folderName}" a été créé !',

  'admin.bookmarks.folder.update.title': 'Éditer le dossier "{folderName}"',
  'admin.bookmarks.folder.update.success': 'Le dossier "{folderName}" a été mis à jour !',

  'admin.bookmarks.folder.delete.title': 'Voulez-vous supprimer le dossier',
  'admin.bookmarks.folder.delete.subtitle': 'Cela supprimera également tous les favoris de ce dossier.',
  'admin.bookmarks.folder.delete.success': 'Le dossier "{folderName}" ainsi que tous ses favoris ont bien été supprimés !',

  'admin.bookmarks.button.createBookmark': 'Créer un favori',
  'admin.bookmarks.button.updateBookmark': 'Modifier le favori',
  'admin.bookmarks.button.deleteBookmark': 'Supprimer le favori',

  'admin.bookmarks.create.title': 'Créer un favori',
  'admin.bookmarks.create.success': 'Le favori "{bookmarkName}" a été créé !',

  'admin.bookmarks.update.title': 'Éditer le favori "{bookmarkName}"',
  'admin.bookmarks.update.success': 'Le favori "{bookmarkName}" a été mis à jour !',

  'admin.bookmarks.delete.title': 'Voulez-vous supprimer le favori',
  'admin.bookmarks.delete.success': 'Le favori "{bookmarkName}" a bien été supprimé !',

  'admin.bookmarks.action.failed.UNKNOWN_ERROR': 'Une erreur inconnue est survenue !',
  'admin.bookmarks.action.failed.UNAUTHORIZED': "Vous n'êtes pas autorisé à effectuer cette opération !",
  'admin.bookmarks.action.failed.DUPLICATE_FOLDERNAME': 'Ce dossier existe déjà !',
  'admin.bookmarks.action.failed.NOT_FOUND': 'Ce favori est introuvable !',
  'admin.bookmarks.action.failed.ALREADY_EXISTS': 'Ce favori existe déjà !',
  'admin.bookmarks.action.failed.FOLDER_ERROR': '',
  'admin.bookmarks.action.failed.EMPTY_FIELD': 'Vous devez renseigner tous les champs !',
  'admin.bookmarks.action.failed.BOOKMARK_LOCKED': 'Ce favori est verrouillé !',
};